function fetchCartData() {
  var cartUrl = '/cart.js';
  $.ajax({
    type: 'GET',
    url: cartUrl,
    dataType: 'json',
    success: function(cartdata) {
      $('.product-change-quantity').addClass('empty-cart');
      $('.quantity_number').text(0);
      $.each(cartdata.items, function(index, cartItem) 
      {
        $(`.product-change-quantity[data-variant_id="${cartItem.id}"]`).removeClass('empty-cart');
        $(`.quantity_number[data-variant_id="${cartItem.id}"]`).text(cartItem.quantity);
      }); 
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('Error fetching cart data:', textStatus);
    }
  });
}

async function getAllSellingPlans(productHandle, customFrequency) {
  var productData = await $.getJSON("/products/" + productHandle + ".js");
  var sellingPlans = productData.selling_plan_groups[0].selling_plans;
  var matchingSellingPlan = sellingPlans[customFrequency];
  var sellingId = matchingSellingPlan ? matchingSellingPlan.id : null;
  return sellingId;
}

var OurCategoriesSlider = function()
{
  $('.collection-all-list-inner').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,

  prevArrow: '<button type="button" class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/1942/8873/files/left-arrow_1.png?v=1686136063" alt="Previous"></button>',
  nextArrow: '<button type="button" class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/1942/8873/files/right-arrow_1.png?v=1686136063" alt="Next"></button>',

  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
};

var ScrollToDiv = function()
{
  $(".scrolltodiv").on("click", function(event) {
  event.preventDefault();
  var targetDiv = $(this).attr("href");
  $("html, body").animate({
  scrollTop: $(targetDiv).offset().top
  }, 800);
  });
};
var callSlickSlider = function()
{
    $('.quick-product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows: true,
    infinite: true,
    swipeToSlide: true,
    autoplay: false,
    prevArrow: '<button class="slide-arrow prev-arrow slick-arrow"><img src="https://cdn.shopify.com/s/files/1/1942/8873/files/left-arrow_1.png?v=1686136063"></button>',
    nextArrow: '<button class="slide-arrow next-arrow slick-arrow"><img src="https://cdn.shopify.com/s/files/1/1942/8873/files/right-arrow_1.png?v=1686136063"></button>'
    });
};

var callAccordian = function()
{
  const accordionHeaders = document.querySelectorAll('.accordion-wrapper .accordion-header');
  accordionHeaders.forEach(header => {
  header.addEventListener('click', function() {
  const activeHeader = document.querySelector('.accordion-wrapper .accordion-header.active');
  if (activeHeader && activeHeader !== this) {
  activeHeader.classList.remove('active');
  activeHeader.nextElementSibling.style.display = 'none';
  }
  this.classList.toggle('active');
  const content = this.nextElementSibling;
  if (content.style.display === 'block') {
  content.style.display = 'none';
  } else {
  content.style.display = 'block';
  }
  });
  });
};

var QuickViewATCBtn = function()
{
    $(document).on("click",".qv-atc",function() {
        var variant_id = $(this).attr('data-variant_id');
        $(`.quick-add[data-variant_id="${variant_id}"] button`).trigger('click');
        var modal = document.getElementById('qv-popupModal');
        var popupContent = document.getElementById('qv-popupContent');
        setTimeout(function() {
        modal.style.display = 'none';
        popupContent.innerHTML = '';
        },500);
    });
};

var QuickViewRatingBtn = function(){
    $(document).on("click",'.quick-stars-rating > a',function(event) {
    event.preventDefault();
    var targetElement = $('#ReviewsWidget');
    if (targetElement.length > 0) 
    {
      $('#ReviewsWidget').trigger('click');
      $('#qv-popupContent').animate({
          scrollTop: 750
      }, 500);
    }
    });
};

var QuickViewPopup = function()
{
  document.addEventListener('DOMContentLoaded', function() {
    var quickviewLinks = document.getElementsByClassName('quickview_product');
    var modal = document.getElementById('qv-popupModal');
    var popupContent = document.getElementById('qv-popupContent');
    for (var i = 0; i < quickviewLinks.length; i++) {
      quickviewLinks[i].addEventListener('click', function(event) {
        event.preventDefault(); 
        var href = this.getAttribute('href');
        fetch(href) 
          .then(response => response.text())
          .then(content => {
            popupContent.innerHTML = content;
            modal.style.display = 'block';
            callSlickSlider();
            callAccordian();
          })
          .catch(error => {
            console.log('Error:', error);
          });
      });
    } 
    var closeButton = document.getElementsByClassName('qv-close')[0];
    modal.addEventListener('click', function(event) {
      if (event.target === modal || event.target === closeButton) {
        modal.style.display = 'none';
        popupContent.innerHTML = '';
      }
    });
  });
};

var CartIconClickable = function()
{
$("body.customcartdrawer #cart-icon-bubble").click(function(event){ event.preventDefault(); window.location.href = $(this).attr('href'); });
};

var DrawerOpenForMobile = function()
{
  $(document).on("click",'button.drawer__close.arrow_up_down',function(event) {
  event.preventDefault();
  $('.collection-right-area').toggleClass("open");
  });
};


var CartDrawerFunctionality = function() {
  $('.button__grey-plus').click(function(event){
      event.preventDefault();
      cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var variant_id = $(this).attr('data-variant_id');
      var item = {};
      item.id = variant_id;
      item.quantity =1;
      item.sections = cartselector.getSectionsToRender().map((section) => section.id);
      var data = item;
      $.ajax({
      type: 'post',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(resp) 
      {
        console.log(resp);
        //var current_value = Number($(`.quantity_number[data-variant_id="${variant_id}"]`).text());
        var current_value = Number($(this).closest('.quantity-block').find(`.quantity_number[data-variant_id="${variant_id}"]`).text());
        current_value = parseInt(current_value);
        console.log(current_value);
        var new_value = resp.quantity;
        $(`.quantity_number[data-variant_id="${variant_id}"]`).text(new_value);
        $(`cart-drawer`).removeClass('is-empty');
        $(`cart-drawer-items`).removeClass('is-empty');
        $(`.product-change-quantity[data-variant_id="${variant_id}"]`).removeClass('empty-cart');
        cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        cartselector.getSectionsToRender().map((section) => section.id);
        cartselector.renderContents(resp);
      }
      });
      return false;
  });
  $('.button__grey-minus').click(function(event){
      event.preventDefault();
      cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var variant_id = $(this).attr('data-variant_id');
      //var current_value = Number($(`.quantity_number[data-variant_id="${variant_id}"]`).text());
      var current_value = Number($(this).closest('.quantity-block').find(`.quantity_number[data-variant_id="${variant_id}"]`).text());
      current_value = parseInt(current_value);
      var new_value = current_value - 1;
      var cartUrl = '/cart/change.js';
      var data = {
      quantity: new_value,
      id: variant_id,
      sections: cartselector.getSectionsToRender().map((section) => section.id)
      };
      $.ajax({
      type: 'POST',
      url: cartUrl,
      data: data,
      dataType: 'json',
      success: function(resp) {
      if(new_value === 0)
      {
        $(`.product-change-quantity[data-variant_id="${variant_id}"]`).addClass('empty-cart');
      }
      $(`.quantity_number[data-variant_id="${variant_id}"]`).text(new_value);
      if(resp.item_count === 0)
      {
      $(`cart-drawer`).addClass('is-empty');
      $(`cart-drawer-items`).addClass('is-empty');
      }
      cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      cartselector.getSectionsToRender().map((section) => section.id);
      cartselector.renderContents(resp);
      },
      error: function(XMLHttpRequest, textStatus) {
      console.log('Error decreasing variant quantity in cart:', textStatus);
      // Handle the error condition if necessary
      }
      });
      return false;
  });
  $(document).on("click",'a#customCheckoutbtn',function(event) {
  event.preventDefault();
  let _this =  $(this);
  $(this).addClass('disabled');
  $('.loadingimage').css('display','flex');
  setTimeout(function(){
    $('.loadingimage').css('display','none');
     _this.removeClass('disabled');
  }, 100);
  var purchaseType = $(this).attr('data-purchase_type');
  var selected_option = $('.recharge-subscriptions-wrapper input[type="radio"]:checked').val();
  if(purchaseType == selected_option)
  {
    $("#CartDrawer-Checkout").trigger('click');
  }
  else
  {
    var itemsList = [];
    var customFrequency = $("#custom-frequency").val();
    $.getJSON('/cart.js', function(cart) {
    var cartItems = cart.items;
    $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    dataType: 'json',
    success: function(response) {
    console.log("Cart cleared successfully:", response);
          var promises = cartItems.map(function(currentItem) 
    {
    var variantId = currentItem.variant_id;
    var quantity = currentItem.quantity;
    var item = {
    id: variantId,
    quantity: quantity
    };
    if (selected_option == "2") {
      return getAllSellingPlans(currentItem.handle, customFrequency)
      .then(function(sellingId) {
      item.selling_plan = sellingId;
      return item;
      });
    }
    return Promise.resolve(item); 
    });
    Promise.all(promises)
    .then(function(items) {
    itemsList = items;
    var data = {
    "items": itemsList
    };
    $.ajax({
    type: 'post',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function() {
      console.log('beforesend');
    },
    success: function(resp) 
    {
      window.location.href='/checkout';
    },
    error: function(resp) {
      var str = resp.responseText;
      console.log('error',str);
    }
    });
    })
    .catch(function(error) {
    console.log("Error:", error);
    });
    },
    error: function(xhr, status, error) {
    console.log("Error clearing cart:", error);
    }
    });
    });
  }
  return false;
});
$(window).on('popstate', function(event) {
  $('.loadingimage').css('display','none');
});
  $(document).on("change",'.recharge-subscriptions-wrapper input[type="radio"]',function(event) {
  event.preventDefault();
  var selected_option = $(this).val();
  if(selected_option == "1")
  {
    $('.addToCart__select select').prop('disabled', true);
  }
  else
  {
    $('.addToCart__select select').prop('disabled', false);
  }
});
};

var logoSliderWrap = function(){
  $('.logo_slider_wrapper .logo_slide_wrap').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
          {
          breakpoint: 1024,
          settings: {
              slidesToShow: 6
          }
          },
          {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
          }
          }
      ]
  });
}
// Transparent Header scroll script
$(function() {
  var header = $(".header");  
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            header.addClass("header_scrolled");
        }else{
            header.removeClass("header_scrolled");
        }
    }); 
});

CartDrawerFunctionality();
DrawerOpenForMobile();
CartIconClickable();
logoSliderWrap();
OurCategoriesSlider();
ScrollToDiv();
QuickViewRatingBtn();
QuickViewATCBtn();
QuickViewPopup();
$(document).on('shopify:section:load', function(event) 
{
CartDrawerFunctionality();
DrawerOpenForMobile();
CartIconClickable();
logoSliderWrap();
OurCategoriesSlider();
ScrollToDiv();
QuickViewRatingBtn();
QuickViewATCBtn();
QuickViewPopup();
});

// ToggleClass in body
$('.menu-open-drawer').click(function(){
  $('body').toggleClass('menu-drawer-open');
});

// On change subscription button
// On change subscription button
$(document).ready(function(){
  $(document).on('change', '.subscription_button_wrap input[name=prductType]', function(){
    var sub_price = $(this).data('price');
    // Update the prices in the specified elements
    $('.cart-drawer__footer .totals__subtotal-value').text(sub_price);
    $('.drawer__heading .cartPrice').text(sub_price);
  });
});


// ARTICLES RELATED PRODUCT ADD TO CART
$(document).ready(function(){
  $('.recipe-add-to-cart, .customarticle-add-to-cart, .customarticlerecipe-add-to-cart').click(function(e){
    e.preventDefault();
    var recipe_product_id = $(this).attr('data-product-id');
    $(this).css({ "background": "#188351", "color": "#fff", "border": "1px solid #188351" });
    var cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    $.ajax({
        url: '/cart/add.js',
        type: 'POST', 
        dataType: 'json', 
        data:{quantity:1 ,id:recipe_product_id,sections:cartselector.getSectionsToRender().map((section) => section.id)},
        success: function(data){
          cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          cartselector.classList.remove('is-empty');
          cartselector.getSectionsToRender().map((section) => section.id);
          cartselector.renderContents(data);
          $('.custom-cart-icon').addClass('custom-cart-animate');
          setTimeout(function() {
            $(".recipe-add-to-cart, .article_product_added").css({ "background": "#fff", "color": "#000", "border": "1px solid #000" }); 
          }, 2000);
        }
    });
  });
});

// RECIPE ARTICLE
$(document).ready(function(){
  $('.recipe-image-block .recipe-thumbnail').click(function(e){
    e.preventDefault();
    var data_index = $(this).data('index');
    $('.recipe_img').removeClass('active');
    $('.recipe_img[data-index="'+data_index+'"]').addClass('active');
    if($(this).hasClass('recipe-thumbnail-video')){
      $('.recipe_video[data-index="'+data_index+'"]').addClass('active');
    }
  });

  // RECIPE ARTICLE ACCORDION
  $('.recipe-accordion-content .recipe-acc-title').click(function(){
    var IsActive = $(this).hasClass('active');
    if(IsActive){
      $(this).removeClass("active")
      $(".recipe-accordion-content .recipe-acc-desc").slideUp();
    }else{
      $(".recipe-accordion-content .recipe-acc-desc").slideUp();
      $(".recipe-accordion-content .recipe-acc-title.active").removeClass("active");
      $(this).addClass("active").next(".recipe-acc-desc").slideDown();
    }
  });

// RECIPE ARTICLE PRODUCT SLIDER
  $('.recipe-product-block').slick({
      autoplay: true,
      autoplaySpeed: 2000,
      dots:true,
      speed: 500,
      arrows:false,
      responsive: [{
      breakpoint: 99999,
              settings: "unslick"
          },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
              slidesToScroll: 1,
          }
        }
      ]
  });
});

$(document).on('click', 'body.normalcartdrawer .drawer__close', function () {
  $('body').removeClass('overflow-hidden');
  $('body.normalcartdrawer .drawer').removeClass('active');
});
$(document).on("click", ".add-to-cart-button", function(e) {
  e.preventDefault();
  var $button = $(this);
  $button.css("opacity", "0.6").prop("disabled", true);
  var cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var variant_id = $button.attr('data-varid');
  var item = {
    id: variant_id,
    quantity: 1,
    sections: cartselector.getSectionsToRender().map((section) => section.id)
  };
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data: item,
    dataType: "json",
    success: function(resp) {
      cartselector.classList.remove('is-empty');
      cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      cartselector.getSectionsToRender().map((section) => section.id);
      cartselector.renderContents(resp);
    },
    complete: function() {
      $button.css("opacity", "1").prop("disabled", false);
    }
  });
  return false;
});


$(document).on('click', '#menu-drawer .cross-icon-new', function (e) {

  e.preventDefault();
  e.stopPropagation();

  const oldSummary = document.querySelector(
    '#Details-menu-drawer-container > summary.header__icon--menu'
  );

  if (oldSummary) {
    oldSummary.click();
  }

});

document.addEventListener('DOMContentLoaded', function () {
  const box = document.querySelector('.reedem_code');
  const inner = document.querySelector('.reedem_inner');
  const content = document.querySelector('.reedem_hidden');
  if (!box || !inner || !content) return;
  inner.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') return;
    if (box.classList.contains('active')) {
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
      box.classList.remove('active');
    } else {
      content.style.height = content.scrollHeight + 'px';
      box.classList.add('active');
    }
  });
  
  (function () { 
    const redeemBox = document.querySelector('.reedem_code');
    let lastState = null; 

    function checkSubscription() {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget || !widget.shadowRoot) return;
      const selected = widget.shadowRoot.querySelector('.rc-purchase-option__subscription[rc-selected]');
      const isActive = !!selected;
      if (isActive !== lastState) {
        lastState = isActive;
        if (redeemBox) {
          redeemBox.classList.toggle('subscription-active', isActive);
        } 
      }
    }
    setTimeout(checkSubscription, 50);
    setInterval(checkSubscription, 150);
  })();
});